/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresDiagnosis/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresDiagnosis({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/RequiresDiagnosis"
  
}) {
let procedureRequiresDiagnosisValueData = fromData.useDataFormat({ viewPath,
context: 'procedure',
path: 'requires_diagnosis',
format: fromFormat.booleanToYesNo,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="procedure.requires_diagnosis"
 format="/Data/format.js booleanToYesNo"
 text={procedureRequiresDiagnosisValueData}
 size="small"
/>
{children}
</React.Fragment>)
}